'use client';

import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import clsx from 'clsx';
import IngredientAccordion from './IngredientAccordion';
import styles from './Ingredients.module.scss';
import { IngredientsData } from './api';

type IngredientCardProps = {
  card: IngredientsData
  isOpen: boolean;
  onToggle: () => void;
};

const IngredientCard: React.FC<IngredientCardProps> = ({
  card, isOpen, onToggle,
}) => (
  <li
    className={styles.card}
  >
    <IngredientAccordion
      title={card.title}
      subtitle={card.subtitle}
      description={card.description}
      link={card.links?.[0] || null}
      isOpen={isOpen}
      toggleAccordion={onToggle}
    />
  </li>
);

const IngredientList = ({
  list, loading, currentPage, className,
}: { list: IngredientsData[], loading: boolean, currentPage: number, className?: string }) => {
  const [openCard, setOpenCard] = useState<number | null>(null);
  const t = useTranslations('ingredients');

  const toggleAccordion = (id: number) => {
    setOpenCard(openCard === id ? null : id);
  };

  useEffect(() => {
    setOpenCard(null);
  }, [list]);

  if (!list?.length) {
    return <div className={styles.empty}><p>{t('No ingredients available')}</p></div>;
  }
  return (
    <ul className={clsx(styles.ingredientsList, className)}>
      {loading && <div className={clsx(styles.loading, styles.isMobile)} />}
      {list.map((card) => (
        <IngredientCard
          key={`page-${currentPage}-id-${card.id}`}
          card={card}
          isOpen={openCard === card.id}
          onToggle={() => toggleAccordion(card.id)}
        />
      ))}
    </ul>
  );
};

export default IngredientList;
